import { connect } from 'react-redux';
import MessageTimeline from 'common/components/message_timeline';

const mapStateToProps = ({user, message: {threads, fetching}}) => {
  return {
    user: user['profile_data'],
    threads,
    fetching
  }
}

export default connect(mapStateToProps)(MessageTimeline);



// WEBPACK FOOTER //
// ./common/containers/message_timeline.jsx